export default "__VITE_ASSET__30e6a716__"